import { API } from 'aws-amplify'

import { CategoryDto, QuizDto, SignUpUserDto, SubCategoryDto, UpdateUserDto, UserDto } from 'types'

export const getSelf = async (): Promise<UserDto> => {
    return API.get('api', '/users/me ', {})
}


export const updateUser = async ({ email, name, password }: UpdateUserDto): Promise<UserDto> => {
    return API.put('api', '/users/', { body: { email, name, password } })
}

export const finalizeSignUp = async (userId: string, { email, name, role, subscriptionId }: SignUpUserDto): Promise<UserDto> => {
    return API.post('open-api', `/users/${userId}`, { body: { email, name, role, subscriptionId } })
}

export const sendContactInquiry = async (name: string, email: string, message: string, schoolName: string, eanNumber:string, schoolAddress: string, phoneNumber: string): Promise<void> => {
    return API.post('open-api', '/users/registration-inquiry', { body: { fromName: name, fromEmail: email, message, schoolName, eanNumber, schoolAddress, phoneNumber } })
}

export const getUsers = async (): Promise<UserDto[]> => {
    return API.get('api', '/users', {})
}

export const getUserData = async (userId: string): Promise<{user: UserDto, quizzes: QuizDto[], categories: CategoryDto[], subcategories: SubCategoryDto[]}> => {
    return API.get('api', `/users/${userId}/data`, {})
}

export const adminDeleteUser = async (userId: string) => {
    return API.del('api', `/users/${userId}`, {})
}

export const createGeeksterUser = async ({email, password, role}: Partial<SignUpUserDto> ): Promise<UserDto> => {
    return API.post('open-api', '/users/geekster', { body: { email, password, role } })
}

export const createGeeksterUserWithUnilogin = async ({ uniLoginUsername, subscribeNewsLetter }: Partial<SignUpUserDto>): Promise<UserDto> => {
    return API.post('open-api', '/users/geekster-unilogin', { body: { uniLoginUsername, subscribeNewsLetter: subscribeNewsLetter === 'true' } })
}

export const getUniloginUri = async (returnUrl: string): Promise<{ clientUri: string }> => {
    return API.post('open-api', '/unilogin/login', { body:{ returnUrl} })
}

type UniloginRequest = {
    uniLoginUsername: string
    uniLoginTimestamp: string
    uniLoginAuth: string
}

export const loginWithUnilogin = async ({uniLoginUsername, uniLoginTimestamp, uniLoginAuth}: UniloginRequest): Promise<string> => {
    return API.post('open-api', '/unilogin/finalize-login', { body: { uniLoginUsername, uniLoginTimestamp, uniLoginAuth } })
}
